import { SettingsHttpService } from './settings.http.service';

export function SettingFactory(settingsHttpService: SettingsHttpService) {
  return () => settingsHttpService.initializeApp();
}
